import { render, staticRenderFns } from "./SubjectFilterDropdown.vue?vue&type=template&id=230408c5&"
import script from "./SubjectFilterDropdown.vue?vue&type=script&lang=ts&"
export * from "./SubjectFilterDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports